import { render, staticRenderFns } from "./PropertyAdditionalCharges.vue?vue&type=template&id=f7de9e32&"
import script from "./PropertyAdditionalCharges.vue?vue&type=script&lang=js&"
export * from "./PropertyAdditionalCharges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports